import React from 'react';
function SwapHoriz() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default SwapHoriz;
